const authentication = require('../../../react-azure-adb2c2').default;
export const list = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/lists`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/lists`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const contentslist = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/contentslist`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/contentslist`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'get',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const insert = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/insert`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/insert`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const getmonthly = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/getmonthly`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/getmonthly`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const nowmonthly = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/nowmonthly`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/nowmonthly`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const update = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/update`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/update`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const del = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/delete`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/delete`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};

export const monthly_insert = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/monthly_insert`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/monthly_insert`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};


export const monthly_delete = (values: any) => {

    // let url = `http://localhost:5000/api/v1/cash/tellers/monthly_delete`;
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/cash/tellers/monthly_delete`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
};
